import styled from 'styled-components';

export const ContainerImages = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
`;

export const ImageStrip = styled.img`
  width: 430px;
`;

export const ContainerImageInput = styled.div`
  display: flex;
  justify-content: center;
  position: relative;
`;

export const Input = styled.input`
  border-radius: 5px;
  border: none;
  bottom: 140px;
  box-sizing: border-box;
  height: 30px;
  outline: none;
  padding-left: 10px;
  position: absolute;
  width: 75%;
`;

export const ButtonSend = styled.button`
  align-items: center;
  background-color: #000000;
  border-radius: 5px;
  border: none;
  bottom: 90px;
  color: #ffffff;
  cursor: pointer;
  display: flex;
  font-size: 15px;
  font-weight: 700;
  height: 36px;
  justify-content: center;
  position: absolute;
  width: 75%;
`;

export const ButtonPurple = styled.button<{ bottom: string; right?: string }>`
  align-items: center;
  background-color: #4b4472;
  border-radius: 18px;
  border: none;
  bottom: ${(props) => props.bottom};
  right: ${(props) => props.right || '150px'};
  color: #ffffff;
  cursor: pointer;
  display: flex;
  font-size: 18px;
  font-weight: 700;
  height: 36px;
  justify-content: center;
  position: absolute;
  width: 159px;
`;
